import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'cognitive_activity_frequency'

const OPTIONS = [
  {
    value: '0-1',
    translationKey:
      'pages.onboarding.cognitiveActivityFrequency.options.zeroToOne',
  },
  {
    value: '2-3',
    translationKey:
      'pages.onboarding.cognitiveActivityFrequency.options.twoToThree',
  },
  {
    value: '4-5',
    translationKey:
      'pages.onboarding.cognitiveActivityFrequency.options.fourToFive',
  },
  {
    value: 'daily',
    translationKey: 'pages.onboarding.cognitiveActivityFrequency.options.daily',
  },
]

const answers: AnswerType[] = [
  {
    emoji: '🌱',
    title: 'pages.onboarding.cognitiveActivityFrequency.options.zeroToOne',
    value: '0-1',
  },
  {
    emoji: '🧩',
    title: 'pages.onboarding.cognitiveActivityFrequency.options.twoToThree',
    value: '2-3',
  },
  {
    emoji: '📘',
    title: 'pages.onboarding.cognitiveActivityFrequency.options.fourToFive',
    value: '4-5',
  },
  {
    emoji: '🚀',
    title: 'pages.onboarding.cognitiveActivityFrequency.options.daily',
    value: 'daily',
  },
]

export default function CognitiveActivityFrequencyPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const answerValue = input.value

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question:
        'How often do you do cognitive activities like puzzles, reading, or learning?',
      answer_key: answerValue,
      answer: answerValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.cognitiveActivityFrequency.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
